export default function (array, key) {
    const isNotEmpty = (value) => { return value !== '' };
    return array.map((row) => row[key]).filter(isNotEmpty);
}
